import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Helmet } from 'react-helmet'

import ThemeMenuThree from '../../../components/header/ThemeMenuThree';
import PageTitle from '../../../components/page-title/PageTitle';
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo';
import FooterThree from '../../../components/footer/FooterThree';

const Price = () => {
  const navigate = useNavigate(); // Inisialisasi useNavigate
  const [productData, setProductData] = useState([]);

  useEffect(() => {
    // Fetch data from backend API
    const fetchData = async () => {
      try {
        const response = await fetch('https://sumbupulsa.com/harga/getIcons.php');
        const data = await response.json();
        setProductData(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Group products by their "Jenis"
  const groupedByJenis = productData.reduce((acc, product) => {
    if (!acc[product.jenis]) {
      acc[product.jenis] = [];
    }
    acc[product.jenis].push(product);
    return acc;
  }, {});

  const handleProductClick = (productId) => {
    console.log('Mengirim productId ke state:', productId); // Console log untuk debugging
    // Navigasi ke halaman ProductDetails dengan state
    navigate('/product-details', { state: { productId: productId } });
  };

  return (
    <Fragment>
      <div className="main-page-wrapper">
        <Helmet>
          <title>Cek Harga</title>
        </Helmet>
        <ThemeMenuThree />
        <PageTitle title="Pricing" />

        <section className="techy-price pt-145 pb-105 pt-lg-100 pb-lg-60">
          <div className="container">
            <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
              <div className="col-xl-5 col-lg-6 col-md-8">
                <div className="section-title text-center mb-35">
                  <h3 className="sect-title mb-25">Cek Harga Untuk Sumbupulsa</h3>
                  <p>Jika ada kesalahan silahkan sampaikan melalui media yang tertera</p>
                </div>
              </div>
            </div>

            {/* Display Products grouped by "Jenis" */}
            <div className="product-list mt-4">
              {Object.keys(groupedByJenis).map((jenis, index) => (
                <div key={index} className="jenis-section">
                  <h4>{jenis}</h4>
                  <div className="row">
                    {groupedByJenis[jenis].map((product, id) => (
                      <div key={id} className="col-md-4 col-lg-3 mb-4">
                        <div className="product-item text-center">
                          <div
                            onClick={() => handleProductClick(product.id)} // Panggil fungsi handleProductClick
                            className="product-icon-container"
                          >
                            <img
                              src={`http://localhost:3000/uploads/${product.icon}`}
                              alt={`Icon for ${product.label}`}
                              className="product-icon"
                            />
                          </div>
                          <h5>{product.label}</h5>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <NewsletterTwo />
        <FooterThree />
      </div>

      {/* Styling */}
      <style>
        {`
          .jenis-section {
            margin-bottom: 30px;
          }

          .product-list {
            display: flex;
            flex-wrap: wrap;
            gap: 5px;
          }

          .product-item {
            flex: 1 0 30%;
            padding: 15px;
            text-align: center;
          }

          .product-icon {
            max-width: 20%;
            height: auto;
            margin-bottom: 10px;
            cursor: pointer;
          }

          .product-item h5 {
            font-size: 16px;
            margin-bottom: 8px;
            color: #fff;
          }

          .product-item p {
            color: #ddd;
            font-size: 14px;
          }

          h4 {
            font-size: 22px;
            margin-bottom: 20px;
            color: #007bff;
          }
        `}
      </style>
    </Fragment>
  );
};

export default Price;
